import {SNACK_BAR_REQUEST_OPEN} from "../constants/ActionTypes";

export const openSnackBar = (message) => {
  return (dispatch) => dispatch({type: SNACK_BAR_REQUEST_OPEN, message});
};
